module.exports = __webpack_public_path__ + "img/dots.5aa4498.svg";